import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import ScrollableContent from '../../../ScrollableContent';
import Dropdown from '../../../Dropdown';
import DropdownMenu from '../../../Menu';
import { isNullableDropdownGroup, convertNullableGroupToDropdownGroup, } from '../../types';
import s from './StandardMenu.scss';
var StandardMenu = /** @class */ (function (_super) {
    tslib_1.__extends(StandardMenu, _super);
    function StandardMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isLabelSticky: false,
        };
        _this.renderItem = function (item) {
            var icon;
            if (item.icon) {
                icon = React.cloneElement(item.icon, {
                    className: classnames(s['menu-item-icon'], item.iconClassName),
                });
            }
            var componentClass = item.componentClass ? item.componentClass : 'span';
            var componentProps = item.componentProps || {};
            if (item.link) {
                if (!item.componentClass) {
                    componentClass = 'a';
                }
                componentProps = tslib_1.__assign({}, componentProps, { href: item.link, target: item.target, title: item.title });
            }
            var key = item.value || Math.random();
            return (React.createElement(Dropdown.MenuItem, { componentClass: componentClass, componentProps: componentProps, className: classnames(s['menu-item'], item.onClick && s['clickable'], item.disabled && s['disabled'], item.danger && s['danger'], _this.props.itemClassName, item.className), key: key, value: item.value, disabled: item.disabled, selected: item.selected, label: typeof item.label === 'string' ? item.label : undefined, onClick: item.onClick },
                icon,
                _this.renderItemLabel(item)));
        };
        _this.onScrolled = function (scrollTop) {
            _this.setState({ isLabelSticky: scrollTop !== 0 });
        };
        return _this;
    }
    StandardMenu.prototype.render = function () {
        var _a = this.props, label = _a.label, withCardWrapper = _a.withCardWrapper, withPaddings = _a.withPaddings, className = _a.className, labelClassName = _a.labelClassName;
        var isLabelSticky = this.state.isLabelSticky;
        var scrollable = this.props.scrollable || label;
        var content = this.renderMenu();
        if (scrollable) {
            content = (React.createElement(ScrollableContent, { className: s['scrollable-content'], onScrolled: this.onScrolled }, content));
        }
        return (React.createElement("div", { className: classnames(s['root'], withCardWrapper && s['with-card-wrapper'], withPaddings && s['with-paddings'], className) }, label ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classnames(s['label'], isLabelSticky && s['sticky'], labelClassName) }, label),
            content)) : (content)));
    };
    StandardMenu.prototype.renderMenu = function () {
        var _this = this;
        var _a = this.props, items = _a.items, menuClassName = _a.menuClassName, onClose = _a.onClose, onSelect = _a.onSelect, lightText = _a.lightText;
        return (React.createElement(Dropdown.Menu, { className: classnames(s['menu'], lightText && s['light-text'], menuClassName), onClose: onClose, onSelect: onSelect }, items.map(function (item) {
            if (!item) {
                return null;
            }
            if (isNullableDropdownGroup(item)) {
                var group = convertNullableGroupToDropdownGroup(item);
                if (group) {
                    return _this.renderGroup(group);
                }
                return null;
            }
            return _this.renderItem(item);
        })));
    };
    StandardMenu.prototype.renderItemLabel = function (item) {
        // allows some items to separate visually their text label from option label
        if (item.complexLabel) {
            return item.complexLabel;
        }
        return typeof item.label === 'string' ? (React.createElement("span", { className: s['menu-item-text-label'] }, item.label)) : (item.label);
    };
    StandardMenu.prototype.renderGroup = function (group) {
        return (React.createElement(Dropdown.ItemGroup, { className: classnames(s['menu-group'], group.className, this.props.groupClassName), key: group.label || Math.random(), label: group.label, disabled: group.disabled }, group.items.map(this.renderItem)));
    };
    StandardMenu.defaultProps = {
        componentType: DropdownMenu,
        withCardWrapper: true,
        withPaddings: true,
    };
    return StandardMenu;
}(React.PureComponent));
export default StandardMenu;
//# sourceMappingURL=StandardMenu.js.map